import { render } from "./SignUp.vue?vue&type=template&id=2ae97e06&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import "./SignUp.vue?vue&type=style&index=0&id=2ae97e06&scoped=true&lang=css"

import exportComponent from "C:\\vue\\erfcRanking\\erfc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae97e06"]])

export default __exports__